module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-from-top-39ee78e6d42ac56b59a2ece3d12dfbed.svg";